import { Injectable } from '@angular/core';

/**
 * Define model class for get info users history and other models.
 */
export class UsersSearch {
  public supplier_id: number;
  public user_email: string;
  public user_name: string;
}

/**
 * Model for users informations.
 */
export class Users {
  public user_id: number;
  public user_email: string;
  public user_name: string;
  public supplier_name: string;
  public user_emails_detail: string;
  public phone_number: string;
  public user_active: boolean;
  public user_level: string;
  public start_datetime: string;
  public end_datetime: string;
  public period_filter: string;
  public fuelstation_list: string;
  public save_grids: boolean;
  public layout_xml: string;
  public expire_datetime: string;
  public ins_datetime: string;
  public ins_user: string;
  public edit_datetime: string;
  public edit_user: number;
  public father_user: string;
  public father_supplier_name: string;
  public plate: string;
  public last_login: string;
  public sys_start_datetime: string;
  public sys_end_datetime: string;
}

export class EmailNotification {
  email: string;
}

export class UsersLevels {
  ID: number;
  Name: string;
}
export class ListAvailableApps {
  ID: number;
  Name: string;
  Value: string;
}

export class UsersAvailableApps {
  Name: string;
}

export class CreateUserModel {
  public nickname: string;
  public email: string;
  public phone_number: string;
  public available_apps: string;
  public levels: number;
}

export class UpdateUserModel {
  public user_reference_email: string;
  public email: string;
  public services: string;
}
export class UserLevels {
  public id: number;
  public name: string;
  public state: boolean;
}

export class DialogUserModalResponse {
  public isSaveUser: boolean;
  public email: string;
}

export enum UserRole {
  DEVELOP = 'Sviluppo',
  SUPPORT = 'Assistenza',
  ADMIN = 'Amministratori',
  SEC_ADMINISTRATION = 'SegreteriaAmministrativa'
}

export class PatchUserRequest {
  id: number;
  active?: boolean;
  user_level: number;
}

export const IS_OVERVIEW_APP = 'ov';
export const IS_SELFNET_APP = 'sn';
export const SERVICE_SELFNET_APP = 'selfnet';
export const SERVICE_OVERIVEW_APP = 'overview';
